<template>
  <div class="big-order">
    <div class="big-dialog">
        <div class="big-content">
            <span>{{saleData.shopName}}</span>
            <span class="big-name">{{saleData.guideName.substring(0, saleData.guideName.lastIndexOf('-'))}}</span>
            <span>{{saleData.money}}元 大单</span>
        </div>
        <img class="kaola" src="../../../assets/kaola.gif"/>
        <img class="rank" src="../../../assets/Orderbg2.png"/>
    </div>
    
  </div>
</template>

<script>

import { deepMerge } from '@jiaminghi/charts/lib/util/index'

import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'

export default {
  name: 'bigOrder',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    data:{
        type: Object,
        default: () => {}
    }
  },
  data () {
    return {
        mergeData: {shopName:'',guideName:'',money:0},
        saleData:{shopName:'',guideName:'',money:0},
    }
  },
  watch: {
    data() {
      const { calcData } = this
      calcData()
    }
  },
  methods: {
    calcData() {
      const { mergeData,data } = this
      this.saleData = deepMerge(deepClone(mergeData, true), data || [])

    },
  },
  mounted () {
    const { calcData } = this
    calcData()
  }
}
</script>
<style lang="scss" type="text/scss">
    .big-order {
        z-index: 5;
        width: 100%;
        height: 100%;
        position:absolute;
        background: rgba(0, 0, 0, 0.6);
        .big-dialog{
            width: 800px;
            height: 459px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            .kaola{
                width: 200px;
                height: 200px;
                position: absolute;
                left: 100px;
                //top: -90px;
                bottom: 50px;
            }
            .rank{
                width: 800px;
                height: 459px;
            }
            .big-content{
                width: 800px;
                height: 459px;
                position: absolute;
                font-family:SourceHanSansCN-Heavy;
                font-weight: 900;
                font-size: 27px;
                color: red;
                flex:1;
                display:flex;
                flex-direction: column;
                justify-content:center;
                text-align:center;
                margin-top: 40px;
                margin-left: 40px;
                .big-name{
                    font-size: 38px;
                }
            }
        }
    }
   
</style>